module.exports = __webpack_public_path__ + "static/media/satelite.b99f7e5e.svg";